import React from "react"
import cn from "design_system/libs/cn"

interface Banner {
  id: string
  name: string
  imageUrl: string
  theme?: string
}

interface BannerGridProps {
  banners: Banner[]
  selectedId: string | null
  onSelect: (id: string) => void
  disabled?: boolean
}

export function BannerGrid({
  banners,
  selectedId,
  onSelect,
  disabled = false,
}: BannerGridProps) {
  if (banners.length === 0) {
    return (
      <p className="text-gray-500 text-sm py-4">
        No banners available. Complete quests to unlock more!
      </p>
    )
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-1 gap-3">
      {banners.map((banner) => {
        const isSelected = selectedId === banner.id

        return (
          <button
            key={banner.id}
            type="button"
            onClick={() => onSelect(banner.id)}
            disabled={disabled}
            className={cn(
              "relative aspect-3/1 rounded-lg border-2 overflow-hidden transition-all",
              "hover:border-primary-400 hover:shadow-md",
              "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              isSelected
                ? "border-primary-500 ring-2 ring-primary-500"
                : "border-gray-200"
            )}
            title={banner.name}
          >
            <img
              src={banner.imageUrl}
              alt={banner.name}
              className="w-full h-full object-cover"
            />
            {isSelected && (
              <div className="absolute top-1 right-1 w-5 h-5 bg-primary-500 rounded-full flex items-center justify-center shadow">
                <svg
                  className="w-3 h-3 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 bg-linear-to-t from-black/60 to-transparent p-1">
              <span className="text-white text-xs font-medium truncate block">
                {banner.name}
              </span>
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default BannerGrid
